var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.85002 8.00002C1.85002 4.60347 4.60347 1.85002 8.00002 1.85002C11.3966 1.85002 14.15 4.60347 14.15 8.00002C14.15 11.3966 11.3966 14.15 8.00002 14.15C4.60347 14.15 1.85002 11.3966 1.85002 8.00002ZM8.00002 0.150024C3.66459 0.150024 0.150024 3.66459 0.150024 8.00002C0.150024 12.3355 3.66459 15.85 8.00002 15.85C9.86154 15.85 11.5717 15.2021 12.9173 14.1194L18.399 19.6011C18.7309 19.933 19.2691 19.933 19.6011 19.6011C19.933 19.2691 19.933 18.7309 19.6011 18.399L14.1194 12.9173C15.2021 11.5717 15.85 9.86154 15.85 8.00002C15.85 3.66459 12.3355 0.150024 8.00002 0.150024Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.0bd7f75c54d72c6da2c9641421e769f9.svg";
export { ForwardRef as ReactComponent };